<template>
  <b-container fluid v-resize="onResize" :style="{height:containerHeight+'px'}" class="printPage px-0">
    <div class="overflow full-height" v-if="viewingOrder">
      <!-- <b-navbar toggleable type="light" variant="light"> -->
        <div class="d-flex full-width">
          <b-img-lazy :src="statusImage" class="icon" />
          <div class="w-100">
            <div>
              <span class="font-weight-bold">#{{orderNumber}}</span>          
              <div class="float-right no-print">
                <b-button variant="link" size="sm" class=""><i class="fas fa-pencil-alt"></i></b-button>
                
                <b-dropdown size="sm" ref="osStatus" right no-caret variant="link"
                            toggle-class="text-decoration-none" class="py-0" @show="stsOrderEnable">
                  <template #button-content>
                    <i class="fas fa-cog"></i>
                  </template>

                  <b-dropdown-item :disabled='!enabled.status_new'>
                    New<span class="float-right" :class="{'text-success':checked.status_new, 'text-secondary' : !checked.status_new}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_confirm' v-b-modal="'modalOrderConfirm'">
                    Confirm<span class="float-right" :class="{'text-success':checked.status_confirm, 'text-secondary' : !checked.status_confirm}"><i class="fa fa-check"></i></span>                  
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_preparing' @click="updateStatus(getOS.Preparing)" v-if="visible.status_preparing">
                    Preparing<span class="float-right" :class="{'text-success':checked.status_preparing, 'text-secondary' : !checked.status_preparing}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_pack' @click="updateStatus(getOS.Pack)" v-if="visible.status_pack">
                    Pack<span class="float-right" :class="{'text-success':checked.status_pack, 'text-secondary' : !checked.status_pack}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_ready' @click="updateStatus(getOS.Ready)" v-if="visible.status_ready">
                    Ready<span class="float-right" :class="{'text-success':checked.status_ready, 'text-secondary' : !checked.status_ready}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_close' @click="updateStatus(getOS.Closed)">
                    Close<span class="float-right" :class="{'text-success':checked.status_close, 'text-secondary' : !checked.status_close}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-divider></b-dropdown-divider>

                  <b-dropdown-item :disabled='!enabled.status_refund_order' v-if="visible.status_refund_order" @click="onRefund(false)">
                    Refund Order<span class="float-right" :class="{'text-success':checked.status_refund_order, 'text-secondary' : !checked.status_refund_order}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                  <b-dropdown-item :disabled='!enabled.status_refund_cancel' v-if="visible.status_refund_cancel" @click="onRefund(true)">
                    Refund &amp; Cancel<span class="pl-4" :class="{'text-success':checked.status_refund_cancel, 'text-secondary' : !checked.status_refund_cancel}"><i class="fa fa-check"></i></span>
                  </b-dropdown-item>

                </b-dropdown>

                <b-button variant="link" size="sm" class="py-0" @click="printOrder"><i class="fa fa-print"></i></b-button>
              </div>
            </div>
            <div class="d-flex w-100">
              <div class="full-width">{{phone}}</div>
              <div class="full-width" v-if="elapseTime > 0" :style="styleEstimateTime">{{timeFormat(elapseTime)}}</div>              
            </div>
            <div class="d-flex w-100">
              <div class="full-width">{{name}}</div>                                
              <div class="full-width">{{displayDate}}</div>
              <b-button size="sm" variant="outline-primary" v-if="hasNextAvailable" @click="nextStatus">Next</b-button>
            </div>
          </div>
        </div>
      <!-- </b-navbar> -->

      <div v-for="(item, index) in items" :key="index" class="border-bottom p-2">
        <div class="d-flex flex-row full-width">
          <span class="item-quanity text-primary font-weight-bold">{{item.quantity}}</span>
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify font-weight-bold">{{item.title}} </span>
          <span class="item-list-title text-justify font-weight-bold"> {{$c2d(itemTotal(item)) | currency}} </span>
        </div>
        <div v-if="item.specialNote" class="d-flex flex-row full-width font-italic font-weight-bold">
          <span class="px-2"></span>
          ***{{item.specialNote}}
        </div>
        <div class="item-options">
            <div v-for="(option, index) in item.options" :key="`option-${index}`">
              <span class="px-2"></span>
              <span class="text-primary text-center" v-if="option.count > 1">{{option.count}}x</span> 
              <span class="text-justify">{{option.title}}</span>
            </div>                        
        </div>
      </div>
      
      <p class="py-1" />
      <div class="d-flex flex-row full-width">
        <span class="px-1"></span>
        <span class="item-list-title flex-grow-1 text-justify">SubTotal</span>
        <span class="item-list-title text-justify"> {{$c2d(subTotal) | currency}} </span>
      </div>
      <div class="d-flex flex-row full-width" v-if="tax > 0">
        <span class="px-1"></span>
        <span class="item-list-title flex-grow-1 text-justify">{{location.taxName1}}</span>
        <span class="item-list-title text-justify"> {{$c2d(tax) | currency}} </span>
      </div>
      <div class="d-flex flex-row full-width" v-if="tax2 > 0">
        <span class="px-1"></span>
        <span class="item-list-title flex-grow-1 text-justify">{{location.taxName2}}</span>
        <span class="item-list-title text-justify"> {{$c2d(tax2) | currency}} </span>
      </div>
      <div class="d-flex flex-row full-width" v-if="tip > 0">
        <span class="px-1"></span>
        <span class="item-list-title flex-grow-1 text-justify">Tip</span>
        <span class="item-list-title text-justify"> {{$c2d(tip) | currency}} </span>
      </div>
      <div class="d-flex flex-row full-width">
        <span class="px-1"></span>
        <span class="item-list-title flex-grow-1 text-justify">Total</span>
        <span class="item-list-title text-justify"> {{$c2d(total) | currency}} </span>
      </div>

    </div>
    <b-modal id="modalOrderConfirm" ref="modalOrderConfirm" title="Estimated Completion">
      <div class="text-center">
        <div class="h1">{{completionTime}}</div>
        
        <b-button-group size="sm" class="mt-3">
            <b-button v-for="time in [10, 15, 20, 30]" :key="time" :variant="completionTime === time?`dark`:``" @click="completionTime = time">{{time}} min</b-button>        
        </b-button-group>

        <b-form-input class="mt-3" id="estimateCompletionRange"
                      type="range" min="1" max="110" 
                      number v-model="completionTime"/>
 
      </div>
      <template #modal-footer>
        <div>
          <b-button
            variant="danger"
            size="sm"
            @click="updateStatus(getOS.Rejected); hideModalOrderConfirm()">
            Reject
          </b-button>
          <span class="mx-2"/>
          <b-button
            variant="primary"
            size="sm" 
            @click="updateStatus(getOS.Confirmed, completionTime); hideModalOrderConfirm()">
            Confirm
          </b-button>          
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'
const DISPLAY_DATE_TIME_FORMAT = "MM/D hh:mma"

export default {
    components : {
    },
    props : {    },
    computed : { 
		  ...mapState({
        userInfo:"userInfo",
        viewingOrder:"viewingOrder"
		  }),

      location(){
        return this.userInfo ? this.userInfo.location : {}
      },

      getOS() {
          return this.$store.getters.getOrderStatus
      },
      timeZone() {
          return this.$store.getters.timeZone
      },

      statusImage() {
          return require(`@/assets/images/${this.status.icon}.png`)
      },

      _id() {
        return this.viewingOrder ? this.viewingOrder._id : 0
      },
      orderTime() {
          return this.viewingOrder ? this.viewingOrder.orderTime : 0
      },
      startTime() {
          return this.viewingOrder ? this.viewingOrder.startTime : 0
      },
      timeEstimate() {
          return this.viewingOrder ? this.viewingOrder.timeEstimate : 0
      },
      completeTime() {
          return this.viewingOrder ? this.viewingOrder.completeTime : 0
      },
    
      subTotal() {
        return this.viewingOrder ? this.viewingOrder.subTotal : 0;
      },
      tax() {
        return this.viewingOrder ? this.viewingOrder.tax : 0;
      },
      tax2() {
        return this.viewingOrder ? this.viewingOrder.tax2 : 0;
      },
      tip() {
        return this.viewingOrder ? this.viewingOrder.tip : 0;
      },
      total() {
        return this.viewingOrder ? this.viewingOrder.total : 0;
      },
      refund() {
        return this.viewingOrder ? this.viewingOrder.refund : 0;
      },

      name() {
        return this.viewingOrder ? this.viewingOrder.name : ""
      },
      phone() {
        return this.viewingOrder ? this.viewingOrder.phone : ""
      },
      orderNumber() {
        return this.viewingOrder ? this.viewingOrder.orderNumber : ""
      },
      status() {
          let sts = this.viewingOrder ? this.viewingOrder.status : ""
          return this.getOS[sts];
      },
      items() {
        return this.viewingOrder ? this.viewingOrder.items : []
      },

      displayDate() {
          return this.moment(this.orderTime).tz(this.timeZone).format(DISPLAY_DATE_TIME_FORMAT);
      },
      
      hasNextAvailable() {
        return [ this.getOS.Cancelled_Customer, this.getOS.Cancelled_Staff,
                 this.getOS.Closed, this.getOS.Rejected  ].findIndex(({value}) => { return value === this.status.value }) < 0
      },

      styleEstimateTime() {
          let style = {}
          if(this.completeTime) {
              style.color = "#000"
          } else {
              let diffEstimateTime = this.estimateTime()
              if (!diffEstimateTime || diffEstimateTime > 2 * 60 * 1000) {
                  style.color = "#000000"
              } else if (diffEstimateTime >= 0 && diffEstimateTime <= 2 * 60 * 1000) {
                  style.color = "#FF9800"
              } else if (diffEstimateTime < 0) {
                  style.color = "#F06292"
              }
          }
          return style
      },
    },
    data() {
        return {
            completionTime : 30,
            isMobile : false,
            containerHeight : 0,
            timer : '',
            elapseTime : 0,
            checked : { status_new : false, status_confirm : false, status_preparing : false, status_pack : false, status_ready : false, status_close : false, status_refund_order : false, status_refund_cancel : false },
            enabled : { status_new : false, status_confirm : false, status_preparing : false, status_pack : false, status_ready : false, status_close : false, status_refund_order : false, status_refund_cancel : false },
            visible : { status_preparing : false, status_pack : false, status_ready : false, status_refund_order : false, status_refund_cancel : false }
        }
    },
    watch : {

    },
    mounted() {
        this.$nextTick(() => {	
            if(!this.viewingOrder && this.$route.name !== 'Order'){ // this will prevent from Blank Page
              this.$router.replace({ name: 'Order' }) 
            }
        })
    },
    created(){
      this.timer = setInterval(this.updateElapsedTime, 1000)
    },
    destroyed(){

    },
    methods: {
        printOrder(){
          window.print()
        },
        itemTotal({price, quantity, options}) {
            let optionsTotal = 0
            options.forEach(option => {
              optionsTotal += option.price
            })
          return ( optionsTotal + price ) *quantity
        },

        stsOrderEnable() {
          this.$nextTick(() => {
            this.checked.status_new = false;
            this.checked.status_confirm = false;
            this.checked.status_preparing = false;
            this.checked.status_pack = false;
            this.checked.status_ready = false;
            this.checked.status_close = false;

            this.enabled.status_new = false;
            this.enabled.status_confirm = false;
            this.enabled.status_preparing = false;
            this.enabled.status_pack = false;
            this.enabled.status_ready = false;
            this.enabled.status_close = false;

            this.enabled.status_refund_order = false;
            this.enabled.status_refund_cancel = false;

            if (this.status.value === this.getOS.New.value) {
                this.enabled.status_confirm = true
            } else if (!(this.status.value === this.getOS.Rejected.value) && !(this.status.value === (this.getOS.Cancelled_Customer.value) || this.status.value === (this.getOS.Cancelled_Staff.value))) {
                this.enabled.status_confirm = true;
                this.enabled.status_preparing = true;
                this.enabled.status_pack = true;
                this.enabled.status_ready = true;
                this.enabled.status_close = true;
                this.enabled.status_refund_cancel = true;
                {
                    const isRefunded = this.refund > 0;
                    //status_refund_order.setText(isRefunded ? R.string.refunded : R.string.refund_order);
                    this.enabled.status_refund_order = !isRefunded
                }
            } else if (this.status.value === (this.getOS.Cancelled_Customer.value) || this.status.value === (this.getOS.Cancelled_Staff.value)) {
                const isRefunded = this.refund > 0;
                //status_refund_order.setText(isRefunded ? R.string.refunded : R.string.refund_order);
                this.enabled.status_refund_order = !isRefunded;
            }

            this.checked.status_new = (this.status.value === (this.getOS.New.value));
            this.checked.status_confirm = (this.status.value === (this.getOS.Confirmed.value));
            this.checked.status_preparing = (this.status.value === (this.getOS.Preparing.value));
            this.checked.status_pack = (this.status.value === (this.getOS.Pack.value));
            this.checked.status_ready = (this.status.value === (this.getOS.Ready.value));
            this.checked.status_close = (this.status.value === (this.getOS.Closed.value));

            this.checked.status_refund_order = (this.refund > 0);
            this.checked.status_refund_cancel = (this.status.value === (this.getOS.Cancelled_Staff.value));
            
            this.visible.status_preparing = this.userInfo.location.preparingEnabled;
            this.visible.status_pack =  this.userInfo.location.packEnabled;
            this.visible.status_ready =  this.userInfo.location.readyEnabled;      
            this.visible.status_refund_order =  this.userInfo.canRefund;
            this.visible.status_refund_cancel =  this.userInfo.canRefund;
            
         })
        },

        cancelAutoUpdate () { clearInterval(this.timer) },
        estimateTime(){
            return this.moment(this.timeEstimate).tz(this.timeZone).diff(this.moment().tz(this.timeZone))
        },
        updateElapsedTime() {
            let millis = 0;
            if (this.completeTime && this.startTime) {
                millis = this.moment(this.completeTime).diff(this.moment(this.startTime));
            } else if (!(this.status === this.getOS.Cancelled_Customer || this.status  === this.getOS.Cancelled_Staff || this.status === this.getOS.Rejected)) {
                millis = this.moment().tz(this.timeZone).diff(this.moment(this.orderTime).tz(this.timeZone));
            } else {
                //this.cancelAutoUpdate()
            }
            this.elapseTime = millis;
            // let dateDiff = this.dateDiff(this.moment.duration(this.moment().diff(this.moment(this.orderTime))))
        },
        timeFormat(millis) {            
            let d = this.moment.duration(millis);
            let mins = Math.floor(d.asMinutes());
            let seconds = Math.floor(d.asSeconds()) - mins * 60;
            return `${this.$zeroPad(mins, 10)}:${this.$zeroPad(seconds, 10)}`
        },  
        onResize() {
            let navheader = document.getElementById('navheader')            
            if(navheader){
                this.containerHeight = window.innerHeight - navheader.offsetHeight - 10;
            }
            this.isMobile = window.matchMedia('(max-width: 767px)').matches
        },
        nextStatus() {
          if (this.status === (this.getOS.New)) {
            this.$bvModal.show("modalOrderConfirm")
          }
          if (this.status === (this.getOS.Confirmed)) {
              if (this.userInfo.location.preparingEnabled) {
                  this.updateStatus(this.getOS.Preparing)
              } else if (this.userInfo.location.packEnabled) {
                  this.updateStatus(this.getOS.Pack)
              } else if (this.userInfo.location.readyEnabled) {
                  this.updateStatus(this.getOS.Ready)
              } else {
                  this.updateStatus(this.getOS.Closed)
              }
          }
          if (this.status === (this.getOS.Preparing)) {
              if (this.userInfo.location.packEnabled) {
                  this.updateStatus(this.getOS.Pack)
              } else if (this.userInfo.location.readyEnabled) {
                  this.updateStatus(this.getOS.Ready)
              } else {
                  this.updateStatus(this.getOS.Closed)
              }
          }
          if (this.status === (this.getOS.Pack)) {
              if (this.userInfo.location.readyEnabled) {
                  this.updateStatus(this.getOS.Ready)
              } else {
                  this.updateStatus(this.getOS.Closed)
              }
          }
          if (this.status === (this.getOS.Ready)) {
              this.updateStatus(this.getOS.Closed)
          }
          if (this.status === (this.getOS.Rejected)) {
              this.toast(this, { msg :  "Rejected Order", variant : "danger" , appendToast : false})
          }
        },
        updateStatus(_status, timeEstimate) {
          const request = { _id :  this._id, status : _status.value, timeEstimate : timeEstimate }
          this.$store.dispatch("apiUpdateOrderStatus", request)
                     .then(this.thenUpdateStatus)
                     .catch(this.catchUpdateStatus)
        },        
        onRefund(isCancel) {        
          let msgCancel
          if(isCancel) {
           msgCancel = "Are you sure you want to Refund & Cancel this order?";
          } else {
           msgCancel = "Are you sure you want to Refund this order?"
          }
          this.$bvModal.msgBoxConfirm(`${msgCancel}` , 
            { 
              okVariant: 'primary',
              okTitle: 'Confirm',
              cancelTitle: 'Cancel',
              cancelVariant: 'danger',
              buttonSize: 'sm',
              centered: false
            })
            .then(value => {
              if(value) {
                const request = { _id :  this._id }
                if(isCancel) {
                  this.$store.dispatch("apiRefundOrderAndCancel", request)
                             .then(this.thenUpdateStatus)
                             .catch(this.catchUpdateStatus)
                } else {
                  this.$store.dispatch("apiRefundOrder", request)
                             .then(this.thenUpdateStatus)
                             .catch(this.catchUpdateStatus)
                }
              }
            }).catch(err => {
              console.log(err)
            })          
        },
        hideModalOrderConfirm() {
          this.$refs['modalOrderConfirm'].hide()
        },
        thenUpdateStatus({status, error }) {
          if(status) {
            this.toast(this, { msg :  "Updated", variant : "success" , appendToast : false})
          } else {
            this.toast(this, { msg :  "Check Console", variant : "danger" , appendToast : false})
            console.log("Error", error)
          }
        },
        catchUpdateStatus(e) {
          this.toast(this, { msg :  e.msgError, variant : "danger" })
        }
    },    
    beforeDestroy () {
      clearInterval(this.timer)
    }
}
</script>
<style scoped>
    img.icon {
        width: 65px;
        height: 65px;
        padding: 5px;
        margin: auto;
    }
    div.full-width {
        width: 100%;
    }
    .break {
      flex-basis: 100%;
      height: 0;
    }
    .overflow {
        overflow: auto;
    }
    .full-height {
        height: 100%;
    }

    @media print {
      .printPage{
        height: unset !important;
      }
    }
</style>